/**
 * Data system application setting mock
 */

// Utils
import { IParamGetList } from 'models/UserRequest';
import { ParamsGetListSetting } from 'utils/constants';
import { RowHeader } from 'utils/types';

export const headerSystemApplicationSetting: RowHeader[] = [
  { id: 'position', label: 'No', position: 'center' },
  { id: 'is_displayed', label: '利用状況', position: 'center', haveSort: false },
  { id: 'title', label: 'システム名' },
  { id: 'body', label: 'システム説明文' },
  { id: 'callback_url', label: 'システムURL' },
  { id: 'info', label: 'システムアイコン', position: 'center', haveSort: false },
  { id: 'color', label: 'カラーコード' },
  { id: 'created_at', label: '作成日' },
  { id: 'updated_at', label: '更新日' },
  { id: 'edit', label: '登録情報編集', position: 'center', haveSort: false },
];

export const defaultParamsApplicationSetting: IParamGetList = {
  keyword: '',
  order_by: 'asc',
  sort_name: 'position',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
};
